const webConfig = Object.freeze({
    apiHost: process.env.VUE_APP_API_HOST,
    apiHosts: process.env.VUE_APP_API_HOSTS,
});
export default webConfig;